import PropTypes from 'prop-types'

import { STRING } from 'resources'
import { APP_LINK } from 'resources/urls'
import PrimaryLink from 'units/PrimaryLink'

import ReklaimModal, { ModalHeader, ModalBody, ModalTitle } from 'components/ReklaimModal'
import { ButtonsContainer, ConfirmButton, ErrorMessage } from './styles'

const MissingPrimaryIdsModal = ({ isOpen, toggle }) => (
  <ReklaimModal isOpen={isOpen} toggle={toggle} centered>
    <ModalHeader toggle={toggle} />
    <ModalBody>
      <ModalTitle>{STRING.wallet.redemptions.shares.missingIdModal.title}</ModalTitle>
      <ErrorMessage>{STRING.wallet.redemptions.shares.missingIdModal.error}</ErrorMessage>
      <ButtonsContainer>
        <ConfirmButton to={APP_LINK} tag={PrimaryLink} withArrow>
          {STRING.wallet.redemptions.shares.missingIdModal.verify}
        </ConfirmButton>
      </ButtonsContainer>
    </ModalBody>
  </ReklaimModal>
)

MissingPrimaryIdsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default MissingPrimaryIdsModal
